var storage = {
  save: function save(key, value) {},
  fetch: function fetch(key) {
    return null;
  },
  remove: function remove(key) {},
  clear: function clear() {}
};
module.exports = storage;